import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        { path: "/", name: 'Home', component: () => import(/* webpackChunkName: "main" */ "@/components/Main") },
        { path: '/main/:bookingOrderNumber?/:submittedOrders?/:customerId?/:hatchDate?', name: 'Main', component: () => import(/* webpackChunkName: "main" */ "@/components/Main") },
        { path: '/currencies', name: 'Currencies', component: () => import(/* webpackChunkName: "currencies" */ "@/components/Maintenance/Currency/CurrencyTypes") },
        { path: '/approvers', name: 'Approvers', component: () => import(/* webpackChunkName: "approvers" */ "@/components/Maintenance/Approvers/BookingRegions") },
        { path: '/causes', name: 'Causes', component: () => import(/* webpackChunkName: "causes" */ "@/components/Maintenance/Causes/Index") },
        { path: '/reasons', name: 'Reasons', component: () => import(/* webpackChunkName: "reasons" */ "@/components/Maintenance/IncidentReasons/Index") },
        // { path: '/mortalityuploads', name: 'MortalityUploads', component: () => import(/* webpackChunkName: "mortalityUploads" */ "@/components/Maintenance/MortalityUpload/MortalityUpload") },
        { path: '/approvalrequests/:bookingsOrderNumber?/:approvalStatusId?/:hatchDate?', name: 'Approvals', component: () => import(/* webpackChunkName: "approvals" */ "@/components/Approvals/Index") },
        { path: "/signin/", name: "Signin", component: () => import(/* webpackChunkName: "signin" */ "../views/Signin.vue"), props: true },
        { path: "/signout/", name: "Signout", component: () => import(/* webpackChunkName: "signout" */ "../views/Signout.vue") }
    ]
})
